import { SkuApiDto } from '@b2x/storefront-api-js-client/src/dto';

export interface UseStockAvailabilityProps {
  sku?: SkuApiDto;
}

export const useStockAvailability = (sku?: SkuApiDto) => {
  const availability = sku?.warehouseSkus?.reduce((previous, current) => {
    return current.availableStock > 0 ? current.availableStock + previous : previous;
  }, 0);

  return {
    availability,
  };
};
